import camelCase from 'lodash/camelCase';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectSettingsServicedeskJourneyConfigurationRoute } from '@jira/router-routes__project-settings-service-desk-journeys-routes/src/projectSettingsServicedeskJourneyConfigurationRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { journeyConfigPageEntryPoint } from './ui/journey-config/index.tsx';

export const projectSettingsServicedeskJourneyConfigurationRouteEntry: Route = createEntry(
	projectSettingsServicedeskJourneyConfigurationRoute,
	() => ({
		group: 'project-settings-servicedesk',
		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},
		meta: {
			reporting: {
				id: 'jsm.journey-builder.journey-config',
				packageName: camelCase('journey-config'),
				teamName: 'JSM Grape Soju',
			},
		},
		layout: serviceProjectLayout,
		resources: [...getServiceDeskSettingsResources()],
		perfMetricKey: 'jsm-journey-configuration',
		entryPoint: () => journeyConfigPageEntryPoint,
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
